export default "__VITE_ASSET__fa6d09f5__"